import React from "react";
import { fmtCurrency } from "@/lib/calc";
import { planNumbers } from "@/lib/packages";

const Line = ({ label, value, strong, muted, testid }) => (
  <div className={`flex justify-between gap-3 py-1 ${strong ? "font-semibold" : ""} ${muted ? "text-muted-foreground text-xs" : "text-sm"}`} data-testid={testid}>
    <span>{label}</span><span className="tabular-nums">{value}</span>
  </div>
);

// WHAT IT'S WORTH / WHAT YOU PAY / WHAT YOU GAIN — live, dollar-first. Internal metrics kept separate.
export const PlanNumbers = ({ plan, cur, labels }) => {
  const n = planNumbers(plan);
  const f = (v, d = 0) => fmtCurrency(v || 0, cur, d);
  return (
    <div className="space-y-4" data-testid="plan-numbers">
      <div className="rounded-2xl border border-primary/30 bg-primary/5 p-4">
        <div className="font-mono-label text-[11px] uppercase tracking-wider text-muted-foreground mb-1">The numbers — what the client sees</div>
        <Line label={`${labels.packages_bundle_label} · ${n.sessions_total} treatments`} value={f(n.bundle_value)} testid="num-bundle-value" />
        <Line label={`${labels.packages_bribes_label} · extra value`} value={f(n.bribe_value)} testid="num-bribe-value" />
        <Line label="Total value" value={f(n.total_value)} strong testid="num-total-value" />
        <div className="border-t border-primary/20 my-2" />
        <div className="flex items-end justify-between gap-3">
          <div><div className="text-[11px] text-muted-foreground">Pay</div><div className="font-heading font-extrabold text-3xl tabular-nums" data-testid="num-price">{f(n.price)}</div></div>
          <div className="text-right"><div className="text-[11px] text-muted-foreground">You receive</div><div className="font-heading font-bold text-xl text-primary tabular-nums" data-testid="num-advantage">{f(n.total_advantage)} extra value</div></div>
        </div>
        <Line label="Treatment saving" value={f(n.treatment_saving)} muted testid="num-saving" />
        {n.treatment_saving < 0 && <p className="text-xs text-destructive mt-1">Price is above the normal treatment value — clients will see a negative saving.</p>}
      </div>
      <div className="rounded-2xl border border-border p-4">
        <div className="font-mono-label text-[11px] uppercase tracking-wider text-muted-foreground mb-1">Internal — never shown to clients</div>
        <Line label="Effective discount" value={`${(n.effective_discount_pct || 0).toFixed(1)}%`} muted testid="num-eff-pct" />
        <Line label="Revenue per paid treatment" value={f(n.revenue_per_treatment, 2)} muted testid="num-rpt" />
        <Line label="Discount sacrificed" value={f(n.treatment_saving)} muted />
        <Line label="Bribe retail value" value={f(n.bribe_value)} muted />
        <Line label="Bribe cost to you" value={f(n.bribe_cost, 2)} muted testid="num-bribe-cost" />
        <Line label="Total cost of the offer (discount + bribes)" value={f(n.total_cost_to_business, 2)} muted testid="num-total-cost" />
        <Line label="Package revenue" value={f(n.price)} muted />
      </div>
    </div>
  );
};
